import { erc20MinimalAbi } from "./fundingAbi";
import { getReadWeb3, getWriteWeb3, gasPrice, getAccountAddress } from "./index";
import { usdtAbi } from "./abi";
import { USDT_ADDRESS } from "./constants";

const decimalsCache = new Map();

/** ERC-20 无限授权额度 */
const MAX_UINT256 =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";

export async function getTokenDecimals(tokenAddress, web3 = getReadWeb3()) {
  const key = tokenAddress.toLowerCase();
  if (decimalsCache.has(key)) return decimalsCache.get(key);
  const contract = new web3.eth.Contract(erc20MinimalAbi, tokenAddress);
  const dec = Number(await contract.methods.decimals().call());
  if (!Number.isFinite(dec)) {
    throw new Error(`Invalid decimals for token ${tokenAddress}`);
  }
  decimalsCache.set(key, dec);
  return dec;
}

export function toTokenWei(amount, decimals) {
  const web3 = getReadWeb3();
  const s = String(amount).trim();
  if (s === "" || s === undefined || Number.isNaN(Number(s)) || Number(s) < 0) {
    throw new Error("Invalid amount");
  }
  if (Number(s) === 0) {
    return web3.utils.toBN(0);
  }
  const [whole, frac = ""] = s.split(".");
  const fracPadded = (frac + "0".repeat(decimals)).slice(0, decimals);
  const combined = `${whole}${fracPadded}`.replace(/^0+/, "") || "0";
  return web3.utils.toBN(combined);
}

export function fromTokenWei(wei, decimals) {
  const web3 = getReadWeb3();
  const bn = web3.utils.toBN(wei);
  const base = web3.utils.toBN(10).pow(web3.utils.toBN(decimals));
  const whole = bn.div(base).toString(10);
  const rem = bn.mod(base).toString(10).padStart(decimals, "0");
  const trimmed = rem.replace(/0+$/, "");
  return trimmed ? `${whole}.${trimmed}` : whole;
}

function tokenContract(web3, tokenAddress, from) {
  const abi =
    tokenAddress.toLowerCase() === USDT_ADDRESS.toLowerCase() ? usdtAbi : erc20MinimalAbi;
  return new web3.eth.Contract(abi, tokenAddress, from ? { from, gasPrice: "0" } : undefined);
}

export async function getAllowance(tokenAddress, owner, spender, web3 = getReadWeb3()) {
  const c = tokenContract(web3, tokenAddress);
  return c.methods.allowance(owner, spender).call();
}

export async function ensureTokenAllowance(tokenAddress, spender, amountWei) {
  const web3 = getWriteWeb3();
  if (!web3) throw new Error("Wallet not connected");
  const from = getAccountAddress();
  const allowance = await getAllowance(tokenAddress, from, spender, web3);
  const need = web3.utils.toBN(amountWei);
  if (web3.utils.toBN(allowance).gte(need)) return null;
  const c = tokenContract(web3, tokenAddress, from);
  const tx = c.methods.approve(spender, MAX_UINT256);
  const gas = await tx.estimateGas({ from });
  return tx.send({ from, gas: Math.ceil(Number(gas) * 1.2), gasPrice });
}
